module.exports = __webpack_public_path__ + "static/2_3_game-tree-4_DE-687c6641cee46d6429a75c3f40360c8a.svg";